function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    clipPath: "url(#clip0_629_1947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.04499 24.5598H23.955C24.285 24.5598 24.56 24.2848 24.56 23.9548V22.4698H3.43999V23.9548C3.43999 24.3398 3.71499 24.5598 4.04499 24.5598ZM25.55 6.95977C24.615 6.95977 23.9 7.67477 23.9 8.60977C23.9 9.04977 24.065 9.48976 24.395 9.76476L19.445 14.8248L14.77 6.46477C15.265 6.18977 15.595 5.63977 15.595 5.03477C15.595 4.09977 14.88 3.38477 13.945 3.38477C13.01 3.38477 12.295 4.09977 12.295 5.03477C12.295 5.63977 12.625 6.18977 13.12 6.46477L8.44499 14.8248L3.49499 9.76476C3.93499 9.48976 4.09999 9.04977 4.09999 8.60977C4.09999 7.67477 3.38499 6.95977 2.44999 6.95977C1.51499 6.95977 0.799988 7.67477 0.799988 8.60977C0.799988 9.54477 1.51499 10.2598 2.44999 10.2598C2.50499 10.2598 2.55999 10.2598 2.55999 10.2598L3.43999 21.4798H24.56L25.44 10.2598C25.495 10.2598 25.55 10.2598 25.55 10.2598C26.485 10.2598 27.2 9.54477 27.2 8.60977C27.2 7.72977 26.485 6.95977 25.55 6.95977Z",
    fill: "#BEA1FF",
    style: {
      fill: "#BEA1FF",
      fill: "color(display-p3 0.7451 0.6314 1.0000)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_1947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.25 0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.82b02edf168f8ae586fe18b7ef81e792.svg";
export { ForwardRef as ReactComponent };